<div class="bh-block">
    <h2 class="bh-block-title bh-block-title-left bh-block-title-lg">Premium Bundles to Ignite Your Kids Curiosity!</h2>
    <div class="bh-bundles">
        <div class="bh-bundle bh-bundle-banner">
            <img ngSrc="assets/images/backgrounds/bg_bundles.jpg" alt="" width="714" height="1200">
        </div>
        <ng-container *ngFor="let workbook of interface.list; let ci = index">
            <div class="bh-bundle">
                <div class="bh-bundle-thumbnail" routerLink="/store/product/{{workbook.slug}}/" itemscope itemtype="http://schema.org/ImageObject">
                    <img
                            itemprop="contentUrl"
                            ngSrc="{{workbook.thumbnail}}"
                            alt="{{workbook.title}}"
                            title="{{workbook.title}}"
                            width="128"
                            height="177"
                    />
                    <meta itemprop="name" content="{{workbook.title}}">
                    <span itemprop="author" itemscope itemtype="http://schema.org/Organization">
              <meta itemprop="name" content="ArgoPrep">
            </span>
                    <meta itemprop="datePublished" content="2023-10-23">
                    <div class="bh-bundle-badge-bestselling">
                        <span>Best</span>
                        <img ngSrc="./assets/images/backgrounds/yellow_badge.svg" alt="badge" height="48" width="48">
                    </div>
                    <div class="bh-bundle-badge-featured">
                        <span>SALE</span>
                        <img ngSrc="./assets/images/backgrounds/red_badge.svg" alt="badge" height="48" width="48">
                    </div>
                </div>
                <div class="bh-bundle-info">
                    <a routerLink="/store/product/{{workbook.slug}}/" title="{{workbook.title}}">
                        <span>{{workbook.grade || 'Universal'}}</span>
                        <div class="bh-bundle-rating-stars">
                            <ng-container *ngFor="let rating of [].constructor(5); let r = index">
                                <img ngSrc="./assets/images/icons/star-full.svg" alt="star" height="15" width="18"/>
                            </ng-container>
                            <span class="!pt-0.5">({{ workbook.rating || "0" }})</span>
                        </div>
                        <p>{{workbook.title}}</p>
                        <label>{{workbook.variations[0]?.costs?.usd | currency: 'USD':'$' || ''}}</label>
                    </a>
                </div>
            </div>
        </ng-container>
    </div>
</div>
